import appAxios from "services/axios";
import { SuperAdminService } from "services/superAdminService";

class StatsSAService extends SuperAdminService<any> {
  constructor() {
    super("stats");
  }
  getNewUsers() {
    return appAxios.get(`/superadmin/stats/new-users`);
  }
  getActiveDevices() {
    return appAxios.get(`/scripts/total-devices`);
  }
  getNewDevicesCount() {
    return appAxios.get(`/superadmin/stats/new-devices-by-days`);
  }
  getNewDevicesByMonths() {
    return appAxios.get(`/superadmin/stats/new-devices-by-months`);
  }
  async getDeviceVersionNumbers(platform: string) {
    const { data } = await appAxios.get(`/superadmin/stats/device-version-numbers?platform=${platform}`);
    return data;
  }  
  // Общее количество активных устройств по месяцам. То есть количество устройств которые были активны в этом месяце
  getActiveDevicesByMonths() {
    return appAxios.get(`/superadmin/stats/active-devices-by-months`);
  }
}
export default new StatsSAService();
